export default __webpack_public_path__ + "static/media/hp.56c94d43.png";